<span class="spinner"
      [ngClass]="'_' + size">
</span>
